import {ApolloClient, InMemoryCache} from "apollo-boost";
import path from "path";
import config from "../config";
import {createHttpLink} from "apollo-link-http";
import fetch from 'node-fetch'
import { StorageManager } from '@slynova/flydrive'
const appConfig = require(path.join(process.cwd(), 'config'))

const PrismaClient = require(path.join(process.cwd(), 'node_modules', '@prisma', 'client')).PrismaClient;
const knex = require('knex');
const NodeCache = require("node-cache");

export const cacheMap = {};

export const cacheProxy = new Proxy(cacheMap, {
    get: function (target, prop, receiver) {
        if (!target[prop]) {
            target[prop] = new NodeCache;
        }
        return target[prop];
    }
})

export default function createContext(req) {
    const conf = config(req.req)

    return {
        request: req.req,
        prisma: new PrismaClient(),
        db: knex(conf.mysql),
        api: new ApolloClient({
            link: createHttpLink({
                fetch
            }),
            cache: new InMemoryCache({
                resultCaching: false,
                freezeResults: true,
            })
        }),
        storage: new StorageManager(appConfig.storage.default, appConfig.storage),
    }
}
